/**
 * Isolated resolver for the Piezo WASM asset URL, quarantined for the same reason as
 * signWorkerFactory: `import.meta` cannot be parsed by the CRA/babel jest transform, so any module
 * containing it is untestable. Tests jest.mock this file; webpack rewrites the `new URL(...,
 * import.meta.url)` form into an emitted-asset URL, the same one wasm-bindgen resolves to.
 */
export function getPiezoWasmUrl(): string {
  return new URL(
    '@amzn/amzn-piezo-plenum-wasm/piezo-plenum-wasm_bg.wasm',
    import.meta.url,
  ).toString();
}
